import React, { useState, useEffect } from "react";
import { AvField } from 'availity-reactstrap-validation'
import { Input } from "reactstrap";

const InputTime = (props) => {
    const [ compValue, setCompValue ] = useState();
    const { 
        name, 
        errorMessage, 
        defaultValue = "", 
        validate, 
        onChange = null,
        placeholder = "...",
        isAvForm = true
    } = props

    useEffect(() => {
        defaultVal(defaultValue)
    }, [defaultValue])

    const handleChange = (event) => {
        setCompValue(event.target.value)
        if(onChange) {
            onChange(event.target.value)
        }
    }

    const defaultVal = (val) => {
        setCompValue(val)
    }

    return (
        <>
            <Input 
                className="form-control"
                name={name}
                placeholder={placeholder}
                onChange={handleChange}
                type="time"
                step={1}
                value={compValue}
            />
            { isAvForm &&
                <AvField 
                    errorMessage={errorMessage}
                    name={name}
                    type="hidden" 
                    value={compValue} 
                    validate={validate}
                />
            }
        </>
    )
}

export default InputTime